import styled, { DefaultTheme } from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { SharedWrapper } from 'components/shared/RadioButtons/styles'
import { TippyWrapper } from 'components/shared/InfoTooltip/styles'
import { respondAbove } from 'styles/mediaQueries'

interface WrapperProps {
    isChecked: boolean
    theme?: DefaultTheme
}

export const Wrapper = styled(SharedWrapper)<WrapperProps>`
    min-height: 72px;
    padding: 14px 16px;
    width: 100%;

    @media ${respondAbove.xl} {
        width: 165px;
        height: 122px;
        padding-top: 24px;
        padding-bottom: 20px;
    }

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.primary_500};
    }

    ${Box} {
        ${Text} {
            hyphens: manual;
        }
    }
`
export const CustomTippyWrapper = styled(TippyWrapper)`
    .tippy-box {
        @media ${respondAbove.xl} {
            max-width: 370px !important;
            width: max-content;
        }
    }
`
